import { useState } from 'react';
import { AgentCard } from '../components/agents/AgentCard';
import { MOCK_AGENTS } from '../lib/mock-data';

const FILTERS = ['All', 'HVAC', 'DeFi', 'Legal'] as const;

export function DiscoverPage() {
  const [activeFilter, setActiveFilter] = useState('All');
  const agents = MOCK_AGENTS;

  return (
    <div className="social-box p-3">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-lg font-bold" style={{ color: '#29487d' }}>Agent Registry</h2>
        <div style={{ fontSize: '10px' }} className="space-x-1">
          <span className="font-bold">Filter:</span>
          {FILTERS.map((f, i) => (
            <span key={f}>
              <span
                className="cursor-pointer hover:underline font-bold"
                style={{ color: activeFilter === f ? 'var(--accent)' : 'var(--text-link)' }}
                onClick={() => setActiveFilter(f)}
              >
                {f}
              </span>
              {i < FILTERS.length - 1 && ' | '}
            </span>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3" id="discover-grid">
        {agents.map(agent => (
          <AgentCard key={agent.id} agent={agent} />
        ))}
      </div>
    </div>
  );
}
